
import { VProgressCircular } from "vuetify/lib";

export default VProgressCircular.extend({});
